import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ENVIRONMENT_INJECTION_TOKEN } from '@sbd-doug-frontend/shared/lib/injections/environment-injection-token';
import { Observable, map } from 'rxjs';
import { SharedAccountContactItem, SharedContactsResponse, SharedContactsService } from '@sbd-doug-frontend/shared/lib/shared-services/shared-contacts.service';

@Injectable({ providedIn: 'root' })
export class AccountPortalContactsService implements SharedContactsService {
  private _http = inject(HttpClient);
  private _env = inject(ENVIRONMENT_INJECTION_TOKEN);

  getContacts(params: Record<string, any> = {}): Observable<{ contacts: SharedAccountContactItem[]; total: number }> {
    return this._http
      .get<SharedContactsResponse>(`${this._env.apiBaseUrl}/v4/contacts`, { params })
      .pipe(map((r) => ({ contacts: r?.data?.contacts ?? [], total: r?.data?.total_contacts ?? (r?.data?.contacts?.length ?? 0) })));
  }

  createContact(payload: Partial<SharedAccountContactItem>): Observable<SharedAccountContactItem> {
    return this._http
      .post<SharedContactsResponse>(`${this._env.apiBaseUrl}/v4/contacts`, payload)
      .pipe(
        map((r) => {
          const d: any = r?.data as any;
          const contact = d?.contact || (Array.isArray(d?.contacts) ? d.contacts[0] : null);
          return contact as SharedAccountContactItem;
        })
      );
  }
}


